<template>
  <div class="background">
    <div class="title">{{msg}}</div>
  </div>
</template>

<script>
export default {
  name: 'Job',
  components: {},
  data() {
    return {
      msg: ""
    }
  },
  mounted() {
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html, body {
  height: 100%;
  width: 100%;
  Font-size: 25%
}

.background {
  background-image: url("https://tu.ltyuanfang.cn/api/fengjing.php");
  height: 100%;
  width: 100%;
  position: absolute;
  background-size: cover;
  background-position: center;
}

/*{ "position": "absolute", "width":"100%", "height":"100%", "background-size": "100% 100%", "background-repeat": "no-repeat", "background-image": "url('http://4et.oss-cn-beijing.aliyuncs.com/4et/item/61/bg.png')" }
*/

.full {
  opacity: 0.8;
  border-radius: 10px 0;
  background: #FFF;
  position: absolute;
  width: 20%;
  top: 12%;
  left: 50%;
  color: rgb(61, 50, 39);
  font-size: 0.6rem;
  font-weight: bold;
  text-align: center;
}

.gy {
  opacity: 0.8;
  border-radius: 10px 0;
  background: #FFF;
  position: absolute;
  width: 20%;
  top: 12%;
  left: 70%;
  color: rgb(61, 50, 39);
  font-size: 0.6rem;
  font-weight: bold;
  text-align: center;
}

.title {
  opacity: 0.8;
  border-radius: 10px 0;
  background: #FFF;
  position: absolute;
  width: 80%;
  top: 16%;
  left: 10%;
  color: rgb(61, 50, 39);
  font-size: 3rem;
  font-weight: bold;
  text-align: center;
}

.thing {
  position: absolute;
  width: 40%;
  height: 50px;
  top: 75%;
  left: 20%;
  color: rgb(61, 50, 39);
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
}

.start {
  opacity: 0.8;
  border-radius: 10px;
  background: #FFF;
  position: absolute;
  width: 20%;
  height: 50px;
  top: 75%;
  left: 60%;
  color: rgb(61, 50, 39);
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
}

.end {
  opacity: 0.8;
  border-radius: 10px 0;
  background: #FFF;
  position: absolute;
  width: 20%;
  top: 86%;
  left: 20%;
  color: rgb(61, 50, 39);
  font-size: 1.3rem;
  font-weight: bold;
  text-align: center;
}

.list {
  opacity: 0.8;
  border-radius: 10px 0;
  background: #FFF;
  position: absolute;
  width: 20%;
  top: 86%;
  left: 40%;
  color: rgb(61, 50, 39);
  font-size: 1.3rem;
  font-weight: bold;
  text-align: center;
}

.detail {
  opacity: 0.8;
  border-radius: 10px 0;
  background: #FFF;
  position: absolute;
  width: 20%;
  top: 86%;
  left: 60%;
  color: rgb(61, 50, 39);
  font-size: 1.3rem;
  font-weight: bold;
  text-align: center;
}

.ful {
  opacity: 0.8;
  border-radius: 10px 0;
  background: #FFF;
  position: absolute;
  width: 80%;
  top: 16%;
  left: 10%;
  color: rgb(61, 50, 39);
  font-size: 3rem;
  font-weight: bold;
  text-align: center;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/game/works/Job.vue